import { memoize } from '@exodus/basic-utils'
import { z } from '@exodus/zod'

const createEventLogReport = ({ eventLogAtom }) => ({
  namespace: 'eventLog',
  export: async () => eventLogAtom.get(),
  getSchema: memoize(() =>
    z.array(
      z
        .object({
          event: z.string(),
          build: z.string().optional(),
          version: z.string(),
          timestamp: z.number(),
          applicationWillFireClearHookOpts: z
            .object({
              isImporting: z.boolean(),
              isDeleting: z.boolean(),
              walletExists: z.boolean(),
            })
            .optional(),
        })
        .strict()
    )
  ),
})

const eventLogReportDefinition = {
  id: 'eventLogReport',
  type: 'report',
  factory: createEventLogReport,
  dependencies: ['eventLogAtom'],
  public: true,
}

export default eventLogReportDefinition
